import React from "react";
import { useTranslation } from "react-i18next";
import { Box, ButtonBase, ListItem, Typography } from "@mui/material";
import chevronDoubleLeft from "@iconify/icons-mdi/chevron-double-left";
import OcPrivateLayoutSidebarChevron from "oc/components/sidebar-chevron";
import useStyles from "oc/components/sidebar-item/sidebar-item.style";

interface OcSidebarBackMenuProps {
  id: string;
  label: string;
  translation: string;
  onMenuChange: (menu: string) => void;
  targetMenu: string;
  narrowMenu: boolean;
}

export const OcSidebarBackMenu: React.FC<OcSidebarBackMenuProps> = ({
  id,
  label,
  translation,
  onMenuChange,
  targetMenu,
  narrowMenu,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  let menuLabel = t(translation) || label;

  return (
    <Box id={id} className={classes.buttonBase}>
      <ButtonBase
        sx={{
          width: "100%",
        }}
      >
        <ListItem
          sx={{
            color: "white",
            height: "48px",
            clipPath: "polygon(0 0, 94% 0, 100% 100%, 0% 100%)",
            cursor: "pointer",
          }}
          component="div"
          onClick={() => onMenuChange(targetMenu)}
        >
          <OcPrivateLayoutSidebarChevron
            icon={chevronDoubleLeft}
            color="#fff"
          />
          <Box
            style={{
              textTransform: "uppercase",
              paddingLeft: narrowMenu ? "16px" : "8px",
              paddingTop: "2px",
              fontSize: "14px",
              letterSpacing: "0.25px",
            }}
          >
            <Typography variant="body2" color="#fff">
              {menuLabel}
            </Typography>
          </Box>
        </ListItem>
      </ButtonBase>
    </Box>
  );
};

export default OcSidebarBackMenu;
